<div class="d-flex align-items-center justify-content-between mb-3 pt-2 flex-wrap">
  <label class="form-label mb-0 fs-16">Category</label>
  <span>{{ category()?.description ?? 'No category selected' }}</span>
</div>

<div class="d-flex align-items-center gap-2 mb-2">
  <h3 class="form-label mb-0 fs-16">Authorities</h3>

  @if (!isCancelled() && canWriteDeals()) {
    @if (addendumProductTaxes().length < 3) {
      <i class="bi bi-plus-circle text-primary fs-18 cursor-pointer" (click)="addAuthority.set(true)"></i>
    }
  }
</div>
@if (addAuthority()) {
  <div class="d-flex flex-column gap-2 mb-2">
    <div class="bg-white border d-flex flex-column gap-2 p-3 rounded-2">
      <div class="d-flex flex-column gap-2">
        <div class="d-flex align-items-center flex-wrap">
          <label for="selectedTaxAuthorityId" class="form-label"
            >Tax Authority <span class="text-danger">*</span></label
          >
          <span class="fw-400 fs-16 d-flex align-items-center gap-2 ms-auto">
            Tax Rate: <span class="fw-500 text-dark">{{ tempTaxRate()?.rate ?? 0.0 }}%</span></span
          >
        </div>

        <generic-dropdown
          [items]="taxAuthoritiesList()"
          [placeholder]="'Select Tax Authority'"
          [clearable]="true"
          [allowSearch]="true"
          [(ngModel)]="selectedAuthority"
          (ngModelChange)="getTaxRate(); getTaxRatesForAuthority($event)"
        >
        </generic-dropdown>
      </div>

      <div class="d-flex align-items-center justify-content-between gap-2">
        <span class="fw-400 fs-16 d-flex align-items-center gap-2">
          Tax Amount: <span class="fw-500 fs-18 text-primary">${{ tempTaxRate()?.taxAmount ?? 0.0 }}</span></span
        >
      </div>
    </div>
  </div>
}
@for (authority of addendumProductTaxes(); track authority.id) {
  <div class="d-flex flex-column gap-2 mb-3">
    <div class="bg-white border d-flex flex-column gap-2 p-3 rounded-2 position-relative">
      <div class="d-flex flex-column gap-2">
        <div class="d-flex align-items-center gap-2">
          <label for="selectedTaxAuthorityId" class="form-label"
            >Tax Authority <span class="text-danger">*</span></label
          >
          @if (!isCancelled() && canWriteDeals()) {
            <span
              class="ms-auto align-items-center d-flex justify-content-center rounded-2 wh-32 text-danger cursor-pointer text-danger cursor-pointer"
              (click)="deleteTaxAuthority(authority.id)"
              role="button"
            >
              <i class="bi bi-trash"></i>
            </span>
          }
        </div>
        <generic-dropdown
          [items]="taxAuthoritiesList()"
          [placeholder]="'Select Tax Authority'"
          [allowSearch]="true"
          [disabled]="true"
          [ngModel]="authority.taxAuthorityId"
        >
        </generic-dropdown>
      </div>

      <div class="d-flex align-items-center justify-content-between gap-2">
        <span class="fw-400 fs-16 d-flex align-items-center gap-2">
          Tax Amount: <span class="fw-500 fs-18 text-success">${{ authority.taxAmount }}</span></span
        >

        <span class="fw-400 fs-14 d-flex align-items-center gap-2 ms-auto">
          Tax Rate:
          <span class="fw-500 text-dark">{{ authority.taxRate }}%</span>
        </span>
      </div>
    </div>
  </div>
}
@if (canWriteDeals()) {
  <button
    (click)="addNewTaxAuthority()"
    class="btn btn-primary ms-auto justify-content-center btn-h35"
    type="button"
    [disabled]="isCancelled()"
  >
    Save
  </button>
}
